export default function MislabelsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.8643 8.19729L7.05762 4.39062"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4H3.33333C2.97971 4 2.64057 4.14048 2.39052 4.39052C2.14048 4.64057 2 4.97971 2 5.33333V8.11467C2.00008 8.46826 2.1406 8.80734 2.39067 9.05733L6.19733 12.864C6.49863 13.1653 6.90726 13.3345 7.33333 13.3345C7.75941 13.3345 8.16803 13.1653 8.46933 12.864L10.6547 10.6787"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.6666L12.3307 12.3359"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5893 10.9113C13.9335 10.2999 14.0683 9.59267 13.9729 8.89752C13.8776 8.20237 13.5574 7.55751 13.0613 7.06133L10 4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66682 6.66797H4.66016"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2L14 14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
